import styled from 'styled-components';
import get from 'lodash/get';

export const HeadingStyled = styled.h1`
  ${props => get(props.theme.typography, props.typography.mobile)};
  text-align: ${props => props.position};
  @media ${props => props.theme.laptop} {
    ${props => get(props.theme.typography, props.typography.desktop)};
  }
`;
